import { createSelector } from 'reselect';
import snakeCase from 'lodash/snakeCase';
import camelCase from 'lodash/camelCase';
import { getCurrentGruserSlice } from './grusers';
export const getAllModules = (state, gruser)=>{
    var _getCurrentGruserSlice;
    return ((_getCurrentGruserSlice = getCurrentGruserSlice(state, gruser)) === null || _getCurrentGruserSlice === void 0 ? void 0 : _getCurrentGruserSlice.modules) || [];
};
export const getAllModuleIds = createSelector(getAllModules, (modules)=>Object.values(modules || {}).map((m)=>m.id));
export const getModule = (state, gruser, moduleId)=>{
    var _getAllModules;
    return (_getAllModules = getAllModules(state, gruser)) === null || _getAllModules === void 0 ? void 0 : _getAllModules[moduleId];
};
export const getModuleCount = createSelector(getAllModules, (_, gruser, zoneName, moduleName)=>({
        zoneName,
        moduleName
    }), (modules, { zoneName, moduleName })=>{
    var _Object_values;
    const moduleNameSnakeCase = snakeCase(moduleName);
    const zoneNameSnakeCase = snakeCase(zoneName);
    return (_Object_values = Object.values(modules)) === null || _Object_values === void 0 ? void 0 : _Object_values.filter((m)=>m.name === moduleNameSnakeCase && m.zonename === zoneNameSnakeCase).length;
});
export const getModuleData = createSelector(getModule, (m)=>{
    if (!m) {
        return {};
    }
    const { moduleData } = m;
    const { dataKey = '' } = moduleData;
    return moduleData[camelCase(dataKey)] || {};
});
export const getModuleMeta = createSelector(getModule, (m)=>m === null || m === void 0 ? void 0 : m.moduleMeta);
export const getModuleName = createSelector(getModule, (m)=>m === null || m === void 0 ? void 0 : m.name);
export const getModulePrivs = createSelector(getModule, (m)=>m === null || m === void 0 ? void 0 : m.privileges);
export const getModuleVersion = createSelector(getModule, (m)=>m === null || m === void 0 ? void 0 : m.version);
export const getModuleRequests = createSelector(getModule, (m)=>(m === null || m === void 0 ? void 0 : m.requests) || {});
export const getModuleRequestsPath = (state, gruser, moduleId, path)=>{
    var _getModuleRequests;
    return ((_getModuleRequests = getModuleRequests(state, gruser, moduleId)) === null || _getModuleRequests === void 0 ? void 0 : _getModuleRequests[path]) || {};
};
export const getAllModulesByModuleType = createSelector(getAllModules, (_, gruser, moduleName)=>moduleName, (modules, moduleName)=>{
    var _Object_values;
    const moduleNameSnakeCase = snakeCase(moduleName);
    return (_Object_values = Object.values(modules)) === null || _Object_values === void 0 ? void 0 : _Object_values.filter((m)=>m.name === moduleNameSnakeCase);
});
export const getModuleByModuleType = createSelector(getAllModulesByModuleType, (modules)=>modules.pop());
export const getModuleDataByModuleType = createSelector(getModuleByModuleType, (module)=>{
    if (!module) {
        return {};
    }
    const { moduleData } = module;
    const { dataKey = '' } = moduleData;
    return moduleData[camelCase(dataKey)] || {};
});
export const getModuleIdByModuleType = createSelector(getModuleByModuleType, (module)=>module === null || module === void 0 ? void 0 : module.id);
export const canEditModule = createSelector(getModule, (m)=>{
    var _m_privileges;
    return (m === null || m === void 0 ? void 0 : (_m_privileges = m.privileges) === null || _m_privileges === void 0 ? void 0 : _m_privileges.edit) === true;
});
export const canEditModuleType = createSelector(getModuleByModuleType, (m)=>{
    var _m_privileges;
    return (m === null || m === void 0 ? void 0 : (_m_privileges = m.privileges) === null || _m_privileges === void 0 ? void 0 : _m_privileges.edit) === true;
});
export const canDeleteModule = createSelector(getModule, (m)=>{
    var _m_privileges;
    return (m === null || m === void 0 ? void 0 : (_m_privileges = m.privileges) === null || _m_privileges === void 0 ? void 0 : _m_privileges.delete) === true;
});
